import {
    SET_FULL_VIEW_PLAYER,
    SET_HAS_TOUCH_SCREEN,
    SET_SHOW_VIRTUAL_KEYBOARD,
    SET_VIDEO_MUTED,
    SET_VIDEO_VISIBILITY,
    SET_VIEW_MODE,
    TOGGLE_UNREAD_BETS_NOTIFICATION
} from '../constants/actionTypes';
import {isLocalStorageAvailable} from '../helpers/systemHelpers';
import {setItem} from "../helpers/localStorageHelpers";
import {VID_VISIBLE} from "../constants/localStorage";
import {SET_BET_SLIP_VIEW} from './../constants/actionTypes';

export function setIsDesktopMode(isDesktopMode) {
    return {type: SET_VIEW_MODE, isDesktopMode};
}

export function setHasTouchScreen(hasTouchScreen) {
    return {type: SET_HAS_TOUCH_SCREEN, hasTouchScreen};
}

export function setShowVirtualKeyboard(showVirtualKeyboard) {
    return {type: SET_SHOW_VIRTUAL_KEYBOARD, showVirtualKeyboard};
}

export function setIsInFullViewPlayer(isInFullViewPlayer) {
    return {type: SET_FULL_VIEW_PLAYER, isInFullViewPlayer};
}

export function setVideoVisibility(playerUID, isVideoVisible) {
    if (isLocalStorageAvailable) {
        setItem(playerUID, VID_VISIBLE, isVideoVisible);
    }
    return {type: SET_VIDEO_VISIBILITY, isVideoVisible};
}

export function toggleUnreadBetsNotification() {
    return {type: TOGGLE_UNREAD_BETS_NOTIFICATION};
}

export function setVideoMuted(isVideoMuted) {
    return {type: SET_VIDEO_MUTED, isVideoMuted};
}

export function setIsBetSlipSideView(isBetSlipSideView) {
    return {type: SET_BET_SLIP_VIEW, isBetSlipSideView};
}


// WEBPACK FOOTER //
// ./src/actions/systemActions.js